module.exports = __webpack_public_path__ + "fonts/Arciform-2.705300e6.otf";